import { useWedding } from "@/context/WeddingContext";
import { formatMoney } from "@/lib/format";
import RecordManager from "@/components/RecordManager";
import { Store } from "lucide-react";

const CATEGORIES = ["Venue", "Planner", "Photographer", "Videographer", "Florist", "Caterer", "Cake", "DJ", "Band", "Hair", "Makeup", "Dress", "Suit", "Transport", "Decor", "Rentals", "Stationery", "Officiant", "Entertainment", "Other"];
const STATUSES = ["Considering", "Contacted", "Quoted", "Booked", "Paid", "Cancelled"];

export default function Vendors() {
  const { wedding } = useWedding();
  const cur = wedding?.currency || "AUD";
  return (
    <RecordManager entity="vendors" title="Vendors" subtitle="Keep quotes, deposits and booking status for every supplier." icon={Store} emptyLabel="Add Vendor"
      renderCell={(c, it) => {
        if (["quote", "deposit"].includes(c.key)) return formatMoney(it[c.key], cur);
        if (c.key === "balance") return formatMoney((Number(it.quote) || 0) - (Number(it.deposit) || 0), cur);
        if (c.key === "status") return <span className={`text-xs px-2.5 py-1 rounded-full ${it.status === "Booked" || it.status === "Paid" ? "bg-accent/20 text-accent-foreground" : it.status === "Cancelled" ? "bg-destructive/10 text-destructive" : "bg-secondary"}`}>{it.status}</span>;
        return undefined;
      }}
      fields={[
        { key: "name", label: "Vendor name" },
        { key: "category", label: "Category", type: "select", options: CATEGORIES },
        { key: "contact", label: "Contact person" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "website", label: "Website" },
        { key: "package", label: "Package" },
        { key: "quote", label: "Quote", type: "number" },
        { key: "deposit", label: "Deposit paid", type: "number" },
        { key: "status", label: "Booking status", type: "select", options: STATUSES },
        { key: "due_date", label: "Payment due", type: "date" },
        { key: "notes", label: "Notes", full: true, type: "textarea" },
      ]}
      columns={[{ key: "name", label: "Vendor" }, { key: "category", label: "Category" }, { key: "quote", label: "Quote" }, { key: "balance", label: "Balance" }, { key: "status", label: "Status" }]} />
  );
}
